export default "__VITE_ASSET__Cu2v5vB0__"